// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");

function OverlayClosable(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: (
                props.hidden ? "hidden" : ""
              ) + " fixed inset-0 bg-gray-900 opacity-75 z-50 p-20-px"
            });
}

var make = OverlayClosable;

exports.make = make;
/* react/jsx-runtime Not a pure module */
